export const HOME_SECTION_HASH_IDS = ['apps', 'courses'] as const;

export type HomeSectionHashId = (typeof HOME_SECTION_HASH_IDS)[number];

const HEADER_SCROLL_OFFSET = 72;

export const normalizeHashId = (hash: string): string =>
  hash.startsWith('#') ? hash.slice(1) : hash;

export const isHomeSectionHash = (hash: string): hash is `#${HomeSectionHashId}` | HomeSectionHashId => {
  const id = normalizeHashId(hash);
  return HOME_SECTION_HASH_IDS.includes(id as HomeSectionHashId);
};

export const scrollToHomeSection = (
  sectionId: string,
  behavior: ScrollBehavior = 'smooth'
): boolean => {
  const element = document.getElementById(sectionId);
  if (!element) {
    return false;
  }

  const top = element.getBoundingClientRect().top + window.scrollY - HEADER_SCROLL_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
};

export const scrollToHomeSectionWithRetry = (
  sectionId: string,
  behavior: ScrollBehavior = 'smooth'
): (() => void) => {
  const timeouts = [0, 100, 300, 600].map((delay) =>
    window.setTimeout(() => scrollToHomeSection(sectionId, behavior), delay)
  );

  return () => {
    timeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
  };
};
